/**
 * Clinician-related types and interfaces
 */

/**
 * Raw clinician data from API
 */
export interface ClinicianData {
  first_name: string;
  last_name: string;
  username: string;
  title?: string;
  has_logged_in: boolean;
}

/**
 * Processed clinician data with camelCase properties
 */
export interface Clinician {
  firstName: string;
  lastName: string;
  username: string;
  title?: string;
  hasLoggedIn: boolean;
}

/**
 * Converts raw clinician data from API to processed format
 */
export const toClinicianData = (data: ClinicianData): Clinician => ({
  firstName: data.first_name,
  lastName: data.last_name,
  username: data.username,
  title: data.title,
  hasLoggedIn: data.has_logged_in,
});

/**
 * Get full name of clinician
 */
export const getClinicianFullName = (clinician: Clinician): string => {
  return `${clinician.firstName} ${clinician.lastName}`;
};

/**
 * Get display name of clinician with optional title
 */
export const getClinicianDisplayName = (clinician: Clinician): string => {
  return `${clinician.firstName} ${clinician.lastName}${clinician.title ? ` (${clinician.title})` : ''}`;
};
